import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { CreateUserRequest, DeleteUserDto, UserRole, UsersClient } from '../generated/api-client';

export {
  PaginatedResponseOfIdentityUserDto,
  UserBasicDto,
  CreateUserRequest,
  DeleteUserDto,
} from '../generated/api-client';

/**
 * Thin wrapper over the NSwag-generated UsersClient.
 * Only the three endpoints present in the OpenAPI spec are exposed here.
 * The remaining endpoints (updateUser, updateUserStatus, updateUserModules,
 * deleteUser, getUserWithModulesForEdit) are not in the spec and continue
 * to be called directly via HttpClient in the feature service.
 */
@Injectable({ providedIn: 'root' })
export class UsersApiService {
  constructor(private readonly client: UsersClient, private readonly http: HttpClient) {}

  associateMember(id: string, personId: string) {
    return this.http.put<void>(`${environment.apiUrl}/Users/${id}/member`, JSON.stringify(personId), {
      headers: { 'Content-Type': 'application/json' }
    });
  }

  getAll(
    searchTerm?: string | null,
    isActive?: boolean | null,
    page?: number,
    pageSize?: number,
    hasLocalUser?: boolean | null,
    sortBy?: string | null,
    sortDirection?: string,
    ministryId?: number | null,
    ministryUnitId?: string | null,
    membershipUnitId?: string | null,
    role?: UserRole | null,
    roleUnitId?: string | null,
  ) {
    return this.client.getAll(
      searchTerm,
      isActive,
      sortBy,
      sortDirection,
      hasLocalUser,
      ministryId,
      ministryUnitId,
      membershipUnitId,
      role,
      roleUnitId,
      page,
      pageSize,
    );
  }

  getUser(id: string) {
    return this.client.getUser(id);
  }

  createUser(request: CreateUserRequest) {
    return this.client.createUser(request);
  }

  updateUserEmail(id: string, email: string) {
    return this.client.updateUserEmail(id, email);
  }

  updateStatus(id: string, status: boolean) {
    return this.client.updateStatus(id, status);
  }

  deleteUser(id: string, request: DeleteUserDto) {
    return this.client.deleteUser(id, request);
  }
}
